<template>
  <div class="tw-flex tw-flex-col tw-gap-[3px]">
    <div class="tw-flex tw-flex-col tw-gap-[3px]">
      <div class="tw-flex tw-justify-between">
        <div>{{ dataLang["reestr_fines_text39"] }}</div>
        <div class="tw-font-semibold">
          {{ settingOneClick.countSelected }}
        </div>
      </div>
      <div class="tw-flex tw-justify-between">
        <div>{{ dataLang["reestr_fines_text40"] }}</div>
        <div class="tw-font-semibold">
          {{ settingOneClick.finesAmount }}
        </div>
      </div>
      <div class="tw-flex tw-justify-between">
        <div>{{ dataLang["reestr_fines_text41"] }}</div>
        <div class="tw-font-semibold">
          {{ settingOneClick.companyComission }} ({{
            settingOneClick.companyPercent
          }}%)
        </div>
      </div>
      <div class="tw-flex tw-justify-between">
        <div>{{ dataLang["reestr_fines_text42"] }}</div>
        <div class="tw-font-semibold">
          {{ settingOneClick.companyTotal }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  computed: {
   ...mapState("translationModule", ["dataLang"]),
    settingOneClick() {
      return this.$parent?.$parent?.$data?.settingOneClick;
    },
  },
};
</script>
